var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNoads = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m2.294 10.779 2.929 2.928A1 1 0 0 0 5.93 14h4.142a1 1 0 0 0 .707-.294l2.928-2.929A1 1 0 0 0 14 10.07V5.928a1 1 0 0 0-.294-.707l-2.929-2.928A1 1 0 0 0 10.07 2H5.928a1 1 0 0 0-.707.294L2.293 5.223A1 1 0 0 0 2 5.93v4.142a1 1 0 0 0 .294.707zm1.515 4.342A3 3 0 0 0 5.93 16h4.142a3 3 0 0 0 2.121-.88l2.928-2.929A3 3 0 0 0 16 10.07V5.928a3 3 0 0 0-.88-2.121L12.191.879A3 3 0 0 0 10.07 0H5.928a3 3 0 0 0-2.121.88L.879 3.809A3 3 0 0 0 0 5.93v4.142a3 3 0 0 0 .88 2.121l2.929 2.928z",
  fill: "#2C2D2E"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 7,
  width: 8,
  height: 2,
  rx: 1,
  fill: "#2C2D2E"
})));
export { SvgNoads as ReactComponent };